'use client';

import Script from 'next/script';

interface Props {
    cookiebotId?: string
}

export default function ConsentScriptComponent(props: Props) {
    const handleScriptLoad = () => {
        console.log('Cookiebot script loaded');
        // puoi interagire con window o Cookiebot qui
    };

    if (!props.cookiebotId) {
        return null;
    }

    return (
        <Script
            id="Cookiebot"
            async={true}
            src="https://consent.cookiebot.com/uc.js"
            strategy="afterInteractive"
            data-cbid={props.cookiebotId}
            data-blockingmode="auto"
            type="text/javascript"
            onLoad={handleScriptLoad}
        />
    );
}